import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { FormVersionDto } from 'src/core/models/quality-management/form-version.dto';
import { Operators } from 'src/core/models/request/operator.enum';
import { CrudService } from 'src/core/services/crud/crud.service';

@Injectable({
  providedIn: 'root',
})
export class FormVersionSelectorService {
  constructor(
    private service: CrudService,
    private operators: Operators
  ) {}

  getVersions(formId: number): Observable<FormVersionDto[]> {
    return this.service
      .get<FormVersionDto>(FormVersionDto, {
        filters: [
          {
            field: 'formId',
            operator: this.operators.Equals,
            value: formId,
          },
        ],
        sorters: [{ field: 'version', direction: 'DESC' }],
        maxResultCount: 1000,
        skipCount: 0,
      })
      .pipe(map(response => response.items ?? []));
  }
}
